"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var RestUtilities_1 = require("../services/RestUtilities");
var Auth_1 = require("../stores/Auth");
var AuthService = /** @class */ (function () {
    function AuthService() {
    }
    AuthService.isSignedIn = function () {
        return !!Auth_1.default.getUser();
    };
    AuthService.prototype.logIn = function (email, password) {
        return RestUtilities_1.post('api/Auth/Login', {
            email: email, password: password
        })
            .then(function (response) {
            if (!response.isError) {
                Auth_1.default.setUser(response.content);
            }
            return response;
        });
    };
    AuthService.prototype.register = function (email, name, phone) {
        return RestUtilities_1.post('api/Auth/Register', {
            email: email, name: name, phone: phone
        });
    };
    AuthService.prototype.forgotPassword = function (email) {
        return RestUtilities_1.post('api/Auth/ForgotPassword', {
            email: email
        });
    };
    AuthService.prototype.logOut = function () {
        Auth_1.default.removeUser();
    };
    return AuthService;
}());
exports.default = AuthService;
//# sourceMappingURL=Auth.js.map